export default {
  good_afternoon: "Boa tarde",
  good_morning: "Bom dia",
  good_night: "Boa noite",
  welcome: "Bem vindo(a)",
};
